<template>
  <div>
    <div class="eagleContainer">
      <!-- 이글 아이콘 -->
      <div class="eagle">
        <img class="eagleImg" src="@/assets/img/ico_eagle.png"/>
      </div>

      <!-- 본문 박스 -->
      <div class="box">
        <div class="tmpBox">
          <!-- 제목 -->
          <p class="title">{{ title }}</p>
          <!-- 서브 타이틀 (HTML 포함 가능) -->
          <p class="subTitle" v-html="subTitle"></p>
        </div>

        <!-- 버튼 (isBtn이 true일 때만 표시) -->
        <button
          v-if="isBtn"
          class="btn"
          :data-channel="btnType"
          @click="fetch"
        >
          {{ btnName }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'eagleBox',

  // 부모 컴포넌트에서 전달받는 props
  props: [
    'title', // 메인 타이틀
    'subTitle', // 서브 타이틀 (HTML 허용)
    'btn', // (사용되지 않음) → 추후 필요시 삭제 검토
    'btnType', // 버튼 동작 타입 (refrash, ticket, coupon, back)
    'btnName', // 버튼 표시 이름
    'isBtn' // 버튼 노출 여부
  ],
  data () {
    return {}
  },
  methods: {
    fetch () {
      /**
       * refrash : 새로고침
       * ticket : 티켓으로 이동
       * coupon : 쿠폰으로 이동
       * back : 뒤로 가기
       */
      if (this.btnType === 'refrash') {
        location.reload()
      }
      if (this.btnType === 'ticket') {
        this.$router.push({name: 'ticket'})
      }
      if (this.btnType === 'coupon') {
        this.$router.push({name: 'couponExchange'})
      }
      if (this.btnType === 'back') {
        this.$router.go(-1)
      }
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
